import { render, staticRenderFns } from "./cryoem_reservations_dashboard.vue?vue&type=template&id=36cbd2ce&scoped=true&"
import script from "./cryoem_reservations_dashboard.vue?vue&type=script&lang=js&"
export * from "./cryoem_reservations_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cbd2ce",
  null
  
)

export default component.exports